import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AmazonService } from "../../services/amazon.service";
import { ConfigService } from "../../services/configService";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { Seller } from "../../objects/amazon/seller";
import { UserService } from "../../services/userService";

@Injectable()
export class AmazonGuard implements CanActivate, CanActivateChild {
    constructor(private configService: ConfigService, private router: Router, private amazonService: AmazonService, private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        const userId = +Cookie.get(this.configService.config.UserAmazonCookieName);
        
        if (!Cookie.get(this.configService.config.ApiTokenCookieName) || !userId) {
            this.amazonService.setCurrentSeller(null);
            this.router.navigate(['/amazon'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        this.userService.getById(userId).then(resp => {
            this.amazonService.userEmail = resp.Data.Email;
        });

        return this.amazonService.getCurrentSeller().then(seller => {


            if (state.url == "/amazon/info/store" || state.url == "/amazon/info/dashboard") {
                if (seller.UserId == undefined || seller.UserId == null) {
                    this.router.navigate(["amazon/info/seller"]);
                }
            }

            let sellerId = route.params["sellerId"];
            let storeId = route.params["storeId"];
            if (state.url == `/amazon/info/${sellerId}/store/${storeId}/products`) {
                let store = seller.Stores.find(store => store.Id == storeId);

                if (!store || sellerId != seller.Id) {
                    this.router.navigate(['/amazon/info/dashboard']);
                }

            }

            return true;

        })


    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return this.canActivate(childRoute, state);
    }
}


// WEBPACK FOOTER //
// ./app/common/guards/amazonGuard.ts